import React, { ReactNode } from 'react';
import styled from 'styled-components';
import { useNavigate, useLocation } from 'react-router-dom';
import { theme } from '@theme';
import * as DS from '@styles/DesignSystem.styles';
import { Sidebar } from './Sidebar';
import { Header } from './Header';
import { FiShield } from 'react-icons/fi';

interface DashboardLayoutProps {
  children: ReactNode;
}

const MainContent = styled.main`
  flex: 1;
  display: flex;
  flex-direction: column;
  margin-left: 280px;
  transition: margin-left ${theme.transitions.normal};

  @media (max-width: ${theme.breakpoints.lg}) {
    margin-left: 0;
  }
`;

const ContentArea = styled(DS.MainWorkspace)`
  padding: ${theme.spacing.lg} ${theme.spacing.md};

  @media (max-width: ${theme.breakpoints.md}) {
    padding: ${theme.spacing.md};
  }
`;

const SuperAdminButton = styled(DS.ButtonPrimary)`
  font-size: ${theme.typography.sizes.xs};
  display: flex;
  align-items: center;
  gap: ${theme.spacing.xs};
  opacity: 0.7;

  &:hover {
    opacity: 1;
    transform: translateY(-2px);
    box-shadow: ${theme.shadows.md};
  }

  svg {
    font-size: 14px;
  }
`;

const FooterLinks = styled.div`
  display: flex;
  gap: ${theme.spacing.md};

  @media (max-width: ${theme.breakpoints.md}) {
    flex-direction: column;
    gap: ${theme.spacing.sm};
  }
`;

export const DashboardLayout: React.FC<DashboardLayoutProps> = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const isSuperAdmin = location.pathname.startsWith('/superadmin');

  return (
    <DS.AppLayout>
      <Sidebar />
      <MainContent>
        <Header />
        <ContentArea>{children}</ContentArea>
        <DS.Footer>
          <DS.FooterText>
            © 2024 P-Screen by Pradium Tech. Tous droits réservés.
          </DS.FooterText>
          {/* {!isSuperAdmin && (
            <SuperAdminButton onClick={() => navigate('/superadmin')}>
              <FiShield />
              Super Admin
            </SuperAdminButton>
          )} */}
        </DS.Footer>
      </MainContent>
    </DS.AppLayout>
  );
};
